import React, { useContext, useEffect, useRef, useState } from 'react';

import { toast } from 'react-toastify';
import { AppContext } from '../../../../../contexts/AppContext';
import useWarehouseStorageService from '../../../../../app/services/hooks/useWareHouseQuoteStorageService';
import { WarehouseQuoteStorageDataForm } from '../../../../../app/models/WareHouseQuoteStorage';
import { ServiceResponse } from '../../../../../app/services/shared/interfaces';
import LazyLoading from '../../../../../components/LazyLoading';
import WarehouseQuoteStorageShowForm from './forms/WareHouseStorageForms/WareHouseStorageShowForm';
import ButtonSaveForm from '../../../../../components/buttons/ButtonSaveForm';
import ButtonCancelForm from '../../../../../components/buttons/ButtonCancelForm';
import DefaultCard from '../../../../../components/default/DefaultCard';
import useWarehouseQuoteRatesService from '../../../../../app/services/hooks/useWareHouseQuoteRateService';
import WarehouseQuoteRateShowForm from './forms/WareHouseRatesForms/WareHouseRatesShowForm';
import { WarehouseQuoteShowRateDataForm } from '../../../../../app/models/WareHouseQuoteRates';

interface Props {
    rateId: number;
    onSaved?: () => void;
    onCancel: () => void;
    onError?: () => void;
}

const WarehouseQuoteRateShow = ({
    rateId,
    onSaved,
    onCancel,
    onError
}: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {showWarehouseQuoteRate,fetchingShowWarehouseQuoteRate} =
        useWarehouseQuoteRatesService();

    const [showRate, setShowRate] = useState<WarehouseQuoteShowRateDataForm>({});

    useEffect(() => {
        show();
    }, [rateId]);

    const show = () => {
        showWarehouseQuoteRate(rateId, {
                onSuccess: (response: ServiceResponse) => {
                    setShowRate(response.data.rate);

                },

        });
    };

    return (

        <>
                        {!fetchingShowWarehouseQuoteRate ? (
                            <>
                                <WarehouseQuoteRateShowForm
                                  rateForm={showRate}

                                />
                            </>
                        ) : (
                            <LazyLoading />
                        )}

        </>
    );
};

export default WarehouseQuoteRateShow;
